/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_HInputs */

const en_wc_start_h = /** @type {(inputs: Wc_Start_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first WordCraft document`)
};

/**
* | output |
* | --- |
* | "Create your first WordCraft document" |
*
* @param {Wc_Start_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_h = /** @type {((inputs?: Wc_Start_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_h(inputs)
});
export { wc_start_h as "wc.start.h" }